import { IDropdownItem, IDropdownListSearch } from "../../../types/dropdownInterface";
import { VehicleDropdown, VehicleDropdownActionType } from "../../actionTypes/master/vehicleTypeDropdownActionTypes";

export const getVehicleListDropdown = (payload: IDropdownListSearch): VehicleDropdownActionType => ({
  type: VehicleDropdown.GET_VEHICLE_DROPDOWN_LIST,
  payload,
});

export const setVehicleListDropdown = (payload: Array<IDropdownItem>): VehicleDropdownActionType => ({
  type: VehicleDropdown.SET_VEHICLE_DROPDOWN_LIST,
  payload,
});
